import { type Discount } from '@carvana/merch-contracts';
import { isSuccess, type Result } from '@carvana/merch-result';
import { type MerchUiDiscountsResponse } from '~/app/api/v1/discounts/route';
import { httpWithAuth } from '~/clients';
import { MerchUiApiClientId } from '~/constants/common/ApiClientId';
import { getDiscountsUrl } from '~/constants/endpoints';
import { logError } from '~/utilities/loggers';

export default async function fetchDiscounts(
  correlationId: string,
  signal?: AbortSignal
): Promise<Discount[]> {
  const url = getDiscountsUrl({ currentPageUrl: window.location.href });

  const { data } = await httpWithAuth.get<Result<MerchUiDiscountsResponse>>(
    url,
    {
      headers: {
        'x-client-id': MerchUiApiClientId,
        'x-correlation-id': correlationId
      },
      signal
    }
  );

  if (!isSuccess(data)) {
    logError(new Error(data.errorMessage), {
      correlationId,
      location: 'fetchDiscounts'
    });

    return [];
  }

  return data.content.discounts;
}
